import { Box, Chip, Typography } from '@mui/material'
import CollapsibleSection from '../CollapsibleSection'
import { formatDateTime } from '../../utils/dateFormat'

export default function DepositTimelineSection({ events }) {
  const items = Array.isArray(events) ? events : []

  return (
    <CollapsibleSection title="Deposit Timeline" mb={3}>
      {items.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No activity logged for this deposit yet.
        </Typography>
      ) : null}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {items.map((event) => (
          <Box key={event.id}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 0.5 }}>
              <Chip
                label={event.action_label || event.action}
                size="small"
                color="primary"
                variant="outlined"
              />
              {event.actor_type ? (
                <Chip
                  label={String(event.actor_type).toUpperCase()}
                  size="small"
                  variant="outlined"
                  sx={{ bgcolor: '#e3f2fd' }}
                />
              ) : null}
            </Box>
            {event.reason ? (
              <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>
                {event.reason}
              </Typography>
            ) : null}
            {Array.isArray(event.detail_lines) && event.detail_lines.length > 0 ? (
              <Box
                sx={{
                  mt: 1,
                  mb: 1,
                  p: 1.5,
                  bgcolor: '#f9fafb',
                  borderRadius: 1,
                }}
              >
                {event.detail_lines.map((line, i) => (
                  <Typography
                    key={`${event.id}-detail-${i}`}
                    variant="body2"
                    sx={{ color: '#444', mb: i < event.detail_lines.length - 1 ? 0.5 : 0 }}
                  >
                    {line}
                  </Typography>
                ))}
              </Box>
            ) : null}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
              {(event.actor_name || event.actor_email) && (
                <Typography variant="caption" sx={{ color: '#666' }}>
                  by {event.actor_name || event.actor_email}
                  {event.actor_name && event.actor_email ? (
                    <span style={{ color: '#999', marginLeft: 4 }}>
                      ({event.actor_email})
                    </span>
                  ) : null}
                </Typography>
              )}
              <Typography variant="caption" sx={{ color: '#999' }}>
                {formatDateTime(event.created_at)}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </CollapsibleSection>
  )
}
